// import React, { useState, useEffect } from "react";
// import { connect } from "react-redux";
// import { SelectDroits } from "../../redux/actions/GetDroits";
// import "./FeuilleAcces.css";

// /* =========================
//    ROW
// ========================= */
// const Row = ({ label, cons, toggle }) => (
//   <tr>
//     <td>{label}</td>

//     <td style={{ textAlign: "center" }}>
//       <input
//         type="checkbox"
//         checked={cons || false}
//         onChange={() => toggle(label)}
//       />
//     </td>
//   </tr>
// );

// /* =========================
//    HEADER
// ========================= */
// const Header = () => (
//   <thead>
//     <tr>
//       <th>Menu</th>
//       <th>Visible</th>
//     </tr>
//   </thead>
// );

// /* =========================
//    COMPONENT
// ========================= */
// const FeuilleAcces = ({ droits, SelectDroits, ConfigDossier , onClose }) => {
//   const [rights, setRights] = useState({});

//   /* LOAD API */
//   useEffect(() => {
//     if (ConfigDossier) {
//       SelectDroits(
//         ConfigDossier.coddos,
//         ConfigDossier.serveur,
//         ConfigDossier.utilisateur,
//         ConfigDossier.pwd_serveur,
//         ConfigDossier.database
//       );
//     }
//   }, [ConfigDossier, SelectDroits]);
//   // 🔹 UPDATE API
//   const handleSubmit = async () => {
//     // if (!ConfigDossier) return;

//     // setLoading(true);

//     // try {
//     //   const url = `https://www.24-crm.tn/webservice/api/Droits/UpdateLigDroits/?coddos=${encodeURIComponent(ConfigDossier.coddos)}&serveur=${encodeURIComponent(ConfigDossier.serveur)}&user=${encodeURIComponent(ConfigDossier.utilisateur)}&pwd=${encodeURIComponent(ConfigDossier.pwd_serveur)}&database=psdossier`;

//     //   for (const d of ligdroits) {
//     //     const data = {
//     //       cons: !!rights[d.coddr]?.cons,
//     //       ajt: !!rights[d.coddr]?.cre,
//     //       mdf: !!rights[d.coddr]?.mdf,
//     //       sup: !!rights[d.coddr]?.sup,
//     //       ann: false,
//     //       mdfnjours: 5,
//     //       coddr: d.coddr,
//     //       codgrp: d.codgrp,
//     //       coddos: d.coddos,
//     //     };

//     //     await fetch(url, {
//     //       method: "Post",
//     //       headers: {
//     //         "Content-Type": "application/json",
//     //       },
//     //       body: JSON.stringify(data),
//     //     });
//     //   }

//     //   alert("✅ Enregistré !");
//     //   loadData(); // 🔥 recharge après save
//     // } catch (err) {
//     //   console.error(err);
//     //   alert("❌ erreur serveur");
//     // } finally {
//     //   setLoading(false);
//     // }
//   };
//   /* MAP DATA */
//   useEffect(() => {
//     if (droits && droits.length > 0) {
//       const newRights = {};

//       droits.forEach((d) => {
//         if (!d.Visible) return;

//         const key = d.lib;

//         newRights[key] = {
//           cons: d.Edition === 1,
//         };
//       });

//       setRights(newRights);
//     }
//   }, [droits]);

//   /* TOGGLE */
//   const toggle = (key) => {
//     setRights((prev) => ({
//       ...prev,
//       [key]: {
//         ...prev[key],
//         cons: !prev[key]?.cons,
//       },
//     }));
//   };
//   const [loading, setLoading] = useState(false);
//   return (
//     <div className="acces-container">
//       {/* <h3>Feuille des Accès</h3> */}
//  <div className="header">
//      <h3
//         style={{
//           color: "#001f7f",
//           fontWeight: 600,
//           letterSpacing: "0.5px",
//         }} >Paramétrage</h3>
//         <button onClick={handleSubmit} className="btn primary">
//           {loading ? "Enregistrement..." : "Confirmer"}
//         </button>
//         <button onClick={onClose}>✕</button>
//       </div>
//       <div className="table-wrapper">
//         <table className="acces-table">
//           <Header />

//           <tbody>
//             {droits && droits.length > 0 ? (
//               droits
//                 .filter((d) => d.Visible)
//                 .map((d) => (
//                   <Row
//                     key={d.coddr}
//                     label={d.lib}
//                     cons={rights[d.lib]?.cons}
//                     toggle={toggle}
//                   />
//                 ))
//             ) : (
//               <tr>
//                 <td colSpan="2">❌ Aucune donnée</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// /* =========================
//    REDUX
// ========================= */
// const mapStateToProps = (state) => ({
//   droits: state.droits.data,
//   ConfigDossier: state.ConfigDossier,
// });

// const mapDispatchToProps = (dispatch) => ({
//   SelectDroits: (a, b, c, d, e) =>
//     dispatch(SelectDroits(a, b, c, d, e)),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(FeuilleAcces);

import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { SelectDroits } from "../../redux/actions/GetDroits";
import "./FeuilleAcces.css";

/* =========================
   ROW
========================= */
const Row = ({ label, checked, onToggle }) => (
  <tr>
    <td>{label}</td>

    <td style={{ textAlign: "center" }}>
      <input
        type="checkbox"
        checked={checked || false}
        onChange={onToggle}
      />
    </td>
  </tr>
);

/* =========================
   HEADER
========================= */
const Header = () => (
  <thead>
    <tr>
      <th>Menu</th>
      <th>Visible</th>
    </tr>
  </thead>
);

/* =========================
   COMPONENT
========================= */
const FeuilleAcces = ({
  droits,
  SelectDroits,
  ConfigDossier,
  onClose,
}) => {
  const [rights, setRights] = useState({});
  const [loading, setLoading] = useState(false);

  /* =========================
     LOAD API
  ========================= */
  useEffect(() => {
    if (ConfigDossier) {
      SelectDroits(
        ConfigDossier.coddos,
        ConfigDossier.serveur,
        ConfigDossier.utilisateur,
        ConfigDossier.pwd_serveur,
        ConfigDossier.database
      );
    }
  }, [ConfigDossier, SelectDroits]);

  /* =========================
     MAP DATA -> STATE
  ========================= */
  useEffect(() => {
    if (droits && droits.length > 0) {
      const newRights = {};

      droits.forEach((d) => {
        if (!d.Visible) return;

        newRights[d.coddr] = {
          cons: d.Edition === 1,
        };
      });

      setRights(newRights);
    }
  }, [droits]);

  /* =========================
     TOGGLE
  ========================= */
  const toggle = (coddr) => {
    setRights((prev) => ({
      ...prev,
      [coddr]: {
        cons: !prev[coddr]?.cons,
      },
    }));
  };

  /* =========================
     SAVE API (sans body)
  ========================= */
  // const handleSubmit = async () => {
  //   if (!ConfigDossier) return;

  //   setLoading(true);

  //   try {
  //     for (const d of droits) {
  //       if (!d.Visible) continue;

  //       const r = rights[d.coddr] || {};
  //       const value = r.cons ? 1 : 0;

  //       const url = `https://www.24-crm.tn/webservice/api/Droits/UpdateDroits/?coddr=${encodeURIComponent(
  //         d.coddr
  //       )}&value=${value}&coddos=${encodeURIComponent(
  //         ConfigDossier.coddos
  //       )}&serveur=${encodeURIComponent(
  //         ConfigDossier.serveur
  //       )}&user=${encodeURIComponent(
  //         ConfigDossier.utilisateur
  //       )}&pwd=${encodeURIComponent(
  //         ConfigDossier.pwd_serveur
  //       )}&database=psdossier`;

  //       const res = await fetch(url);

  //       if (!res.ok) {
  //         throw new Error("Erreur API");
  //       }
  //     }

  //     alert("✅ Enregistré !");

  //     // 🔥 reload data
  //     SelectDroits(
  //       ConfigDossier.coddos,
  //       ConfigDossier.serveur,
  //       ConfigDossier.utilisateur,
  //       ConfigDossier.pwd_serveur,
  //       ConfigDossier.database
  //     );
  //   } catch (err) {
  //     console.error(err);
  //     alert("❌ erreur serveur");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleSubmit = async () => {
    if (!ConfigDossier) return;
  
    setLoading(true);
  
    try {
      for (const d of droits) {
        if (!d.Visible) continue;
  
        const value = rights[d.coddr]?.cons ? true : false;
  
        const url = `https://www.24-crm.tn/webservice/api/Droits/UpdateDroits/?coddr=${encodeURIComponent(
          d.coddr
        )}&value=${value}&coddos=${encodeURIComponent(
          ConfigDossier.coddos
        )}&serveur=${encodeURIComponent(
          ConfigDossier.serveur
        )}&user=${encodeURIComponent(
          ConfigDossier.utilisateur
        )}&pwd=${encodeURIComponent(
          ConfigDossier.pwd_serveur
        )}&database=psdossier`;
  
        const res = await fetch(url, {
          method: "post",
        });
  
        if (!res.ok) {
          throw new Error(`Erreur API : ${res.status}`);
        }
      }
  
      alert("✅ Enregistré !");
  
      // 🔥 recharger les données
      SelectDroits(
        ConfigDossier.coddos,
        ConfigDossier.serveur,
        ConfigDossier.utilisateur,
        ConfigDossier.pwd_serveur,
        ConfigDossier.database
      );
    } catch (err) {
      console.error("Erreur handleSubmit :", err);
      alert("❌ erreur serveur");
    } finally {
      setLoading(false);
    }
  };
  /* =========================
     RENDER
  ========================= */
  return (
    <div className="acces-container">
      <div className="header">
        <h3
          style={{
            color: "#001f7f",
            fontWeight: 600,
          }}
        >
          Paramétrage
        </h3>

        <div style={{ display: "flex", gap: "10px" }}>
          <button onClick={handleSubmit} className="btn primary">
            {loading ? "Enregistrement..." : "Confirmer"}
          </button>

          <button onClick={onClose}>✕</button>
        </div>
      </div>

      <div className="table-wrapper">
        <table className="acces-table">
          <Header />

          <tbody>
            {droits ? (
              droits
                .filter((d) => d.Visible)
                .map((d) => (
                  <Row
                    key={d.coddr}
                    label={d.lib}
                    checked={rights[d.coddr]?.cons}
                    onToggle={() => toggle(d.coddr)}
                  />
                ))
            ) : (
              <tr>
                <td colSpan="2">❌ Aucune donnée</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

/* =========================
   REDUX
========================= */
const mapStateToProps = (state) => ({
  droits: state.droits.data,
  ConfigDossier: state.ConfigDossier,
});

const mapDispatchToProps = (dispatch) => ({
  SelectDroits: (a, b, c, d, e) =>
    dispatch(SelectDroits(a, b, c, d, e)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeuilleAcces);













// import React, { useState } from "react";
// import "./FeuilleAcces.css";

// const initialMenus = [
//   {
//     label: "Vente",
//     red: true,
//     children: [
//       "Fiche Client",
//       "Devis",
//       "Bon  de Commande",
//       "Bon de Livraison",
//       "Facture",
//       "Bon de Retour",
//       "Avoir Client",
    
//     ],
//   },
//   {
//     label: "Achat",
//     red: true,
//     children: [
//       "Fiche Fournisseur",
//       "Bon Commande FRS",
//       "Facture FRS",
 
//     ],
//   },
//   {
//     label: "Stocks",
//     red: true,
//     children: [
//       "Fiche Article",
//       "Bon D'entrée",
//       "Bon Sortie",
//       "&Mise à jour",
//       "Bon de Sortie Camion",
//       "Bon Retour Fournisseur",
      
//     ],
//   },
//   {
//     label: "Finance",
//     red: true,
//     children: [
//       "Reglement client",
//       "Reglement Fournisseurs",
//       "suivi Bordereau",
//       "Reléve Clients",
//       "Reléve Fournisseur",
//       "Click To Call",
//       "Echéanciers Clients",
//       "Echéanciers Fournisseurs",
//     ],
//   },


// ];

// // Composant ligne (groupe ou item)
// const Row = ({ label, rights, toggle, days, setDays, isGroup, isRed }) => {
//   const key = label.replace(/\s/g, "_");

//   return (
//     <tr className={isRed ? "group-row" : ""}>
//       <td className="menu-col">{label}</td>
//       {["cons", "cre", "mdf", "sup"].map((field) => (
//         <td key={field}>
//           <input
//             type="checkbox"
//             checked={rights[key]?.[field] || false}
//             onChange={() => toggle(key, field)}
//           />
//         </td>
//       ))}
//       <td>
//         <input
//           type="number"
//           min="0"
//           className="days-input"
//           value={days[key] || 0}
//           onChange={(e) => setDays(key, Number(e.target.value))}
//         />
//       </td>
//     </tr>
//   );
// };

// // Composant entête du tableau
// const Header = () => (
//   <thead>
//     <tr>
//       <th>Menu</th>
//       <th>Cons</th>
//       <th>Cre</th>
//       <th>Mdf</th>
//       <th>Sup</th>
//       <th>MDF N Jours</th>
//     </tr>
//   </thead>
// );

// const FeuilleAcces = ({ onClose }) => {
//   const [rights, setRights] = useState({});
//   const [days, setDaysState] = useState({});

//   const toggle = (key, field) => {
//     setRights((prev) => ({
//       ...prev,
//       [key]: { ...prev[key], [field]: !prev[key]?.[field] },
//     }));
//   };

//   const setDays = (key, value) => {
//     setDaysState((prev) => ({ ...prev, [key]: value }));
//   };

//   const toggleAll = (check = true) => {
//     const newRights = {};
//     initialMenus.forEach((group) => {
//       const groupKey = group.label.replace(/\s/g, "_");
//       newRights[groupKey] = { cons: check, cre: check, mdf: check, sup: check };
//       group.children.forEach((item) => {
//         const itemKey = item.replace(/\s/g, "_");
//         newRights[itemKey] = { cons: check, cre: check, mdf: check, sup: check };
//       });
//     });
//     setRights(newRights);
//   };

//   const resetAll = () => {
//     setRights({});
//     setDaysState({});
//   };
 
//   const getAccessData = () => {
//     const data = Object.keys(rights).map((key) => ({
//       key,
//       ...rights[key],
//       days: days[key] || 0,
//     }));
//     console.log("Droits actuels :", data);
//     return data;
//   }; 

//   return (
//     <div className="acces-container">
//       <div className="header">
//         <h3
//         style={{
//           color: "#fff",
//           fontWeight: 600,
//           letterSpacing: "0.5px",
//         }} >Feuille des Accès</h3>
      
//         <button onClick={onClose}>✕</button>
//       </div>

//       <div className="table-wrapper">
//         <table className="acces-table">
//           <Header />
//           <tbody>
//             {initialMenus.map((group) => (
//               <React.Fragment key={group.label}>
//                 <Row
//                   label={group.label}
//                   rights={rights}
//                   toggle={toggle}
//                   days={days}
//                   setDays={setDays}
//                   isGroup={true}
//                   isRed={group.red}
//                 />
//                 {group.children.map((item) => (
//                   <Row
//                     key={item}
//                     label={item}
//                     rights={rights}
//                     toggle={toggle}
//                     days={days}
//                     setDays={setDays}
//                   />
//                 ))}
//               </React.Fragment>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <div className="actions">
//         <button className="primary" onClick={() => toggleAll(true)}>
//           Cocher Tous
//         </button>
//         <button onClick={() => toggleAll(false)}>Décocher Tous</button>
//         {/* <button onClick={resetAll}>Réorganiser Tous</button>
//         <button onClick={getAccessData}>Exporter JSON</button> */}
//         <button onClick={onClose}>Fermer</button>
//       </div>
//       <div className="legend">
//         <span><b>Cons</b>  : Consultation</span>&nbsp;&nbsp;
//         <span><b>Cre</b>  : Création</span>&nbsp;&nbsp;
//         <span><b>Mdf</b>  : Modification</span>&nbsp;&nbsp;
//         <span><b>Sup</b>  : Suppression</span>&nbsp;&nbsp;
//         <span><b>MDF N Jours</b> : Délai de modification</span>
//       </div>    </div>
//   );
// };

// export default FeuilleAcces;